import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // Several requests can fail with 401 at once: handle the expired session only once
  isRedirectingToLogin = false

  // Called after the session was dropped on 401; the router sets it to open the login page
  onUnauthorized = null

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        const { config, response } = error

        // Backend issues Sanctum tokens without refresh: on 401 drop the session and go to login.
        // Login/logout requests handle their own errors.
        if (response && response.status === 401 && !/auth\/(login|logout)/.test(config.url)) {
          this.handleUnauthorized()
        }
        return Promise.reject(error)
      },
    )
  }

  handleUnauthorized() {
    if (this.isRedirectingToLogin) {
      return
    }
    this.isRedirectingToLogin = true

    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
    localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
    localStorage.removeItem('userData')

    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: 'Сессия истекла',
        text: 'Войдите в систему заново',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    })

    if (this.onUnauthorized) {
      this.onUnauthorized()
    }
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
    this.isRedirectingToLogin = false
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }
}
